import { render, staticRenderFns } from "./RadioTab.vue?vue&type=template&id=8599e19c&scoped=true&"
import script from "./RadioTab.vue?vue&type=script&lang=js&"
export * from "./RadioTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8599e19c",
  null
  
)

export default component.exports